import { RootState } from "../../../store";
import { CurrentBudgetType } from "../../utils/types/common";
import { budgetsStateSelector } from "@/store/budgets/selectors/budgetsStateSelector";

export const currentBudgetSelector = (
  state: RootState,
): CurrentBudgetType | null => {
  return budgetsStateSelector(state).currentBudget;
};
